import {takeLatest} from 'redux-saga/effects';
import * as saga from './saga';
import * as ACTION from './constants';

export default function*() {
    yield takeLatest(ACTION.UPDATE_PACKAGE.REQUEST, saga.updatePackage);
    yield takeLatest(ACTION.UPDATE_PACKAGE.SUCCESS, saga.onUpdatePackageSuccess);
    yield takeLatest(ACTION.UPDATE_PACKAGE.FAILED, saga.onUpdatePackageFailed);
}
